import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import { getUnauthorizedDescription } from '@/creditflowresearch/ui/common/components/organisms/constants';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { PATH_ONLY_GRANT_CONTEXT } from '@/creditflowresearch/application/User/access/grants/pagePatterns';

const TopCompaniesRestrictionWrapper = ({ children }) => {
  const { checkAccessByUserPlan, plan } = useUserPlanContext();
  const { checkAccessByUserRegions, checkAccessByUserProducts } = usePageFiltersContext();
  // TODO: remove when the European market opening period ends
  const isOpenAccessPage = useAccessGrant(PATH_ONLY_GRANT_CONTEXT);
  // TODO: remove when the European market opening period ends
  const checks = [
    isOpenAccessPage || checkAccessByUserPlan(UserPlanType.PREMIUM),
    isOpenAccessPage || checkAccessByUserRegions(),
    isOpenAccessPage || checkAccessByUserProducts(),
  ];

  return (
    <CheckUserAccess
      conditions={ [
        {
          // TODO: remove when the European market opening period ends
          checks: [isOpenAccessPage || !UserPlan.isUnauthorized(plan)],
          fallback: (
            <TileAccessFallback
              icon={ null }
              direction="vertical"
              title="View League Tables"
              dataTest="fallbackContainer"
              description={ getUnauthorizedDescription() }
              actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
            />
          ),
        },
        {
          checks,
          fallback: (
            <TileAccessFallback
              icon={ null }
              direction="vertical"
              title="View League Tables"
              dataTest="fallbackContainer"
              description="To view dynamic league tables of the top Issuers, Rating Agencies and Underwriters, please Upgrade your plan."
            />
          ),
        },
      ] }
    >
      { children }
    </CheckUserAccess>
  );
};

export default TopCompaniesRestrictionWrapper;
